export default "__VITE_ASSET__e049db6c__"